import { useState } from "react";
import { Routes, Route } from "react-router-dom";

// Import refactored components
import { Sidebar, MobileHeader } from "../components/admin/Sidebar";
import { DashboardOverview } from "../components/admin/DashboardOverview";
import { UsersManagement } from "../components/admin/UsersManagement";
import { ToolsManagement } from "../components/admin/ToolsManagement";
import { LogsManagement } from "../components/admin/LogsManagement";
import { M3uHistory } from "../components/admin/M3uHistory";
import { SettingsManagement } from "../components/admin/SettingsManagement";
import { FirestickCodes } from "../components/admin/FirestickCodes";
import { ProvidersManagement } from "../components/admin/ProvidersManagement";
import { GiftCodes } from "../components/admin/GiftCodes";

// Main Admin Dashboard Component
const AdminDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background" data-testid="admin-dashboard">
      <Sidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <main className="flex-1 overflow-auto min-w-0">
        <MobileHeader onMenuClick={() => setMobileOpen(true)} />
        <div className="p-4 md:p-6">
          <Routes>
            <Route index element={<DashboardOverview />} />
            <Route path="users" element={<UsersManagement />} />
            <Route path="tools" element={<ToolsManagement />} />
            <Route path="providers" element={<ProvidersManagement />} />
            <Route path="firestick" element={<FirestickCodes />} />
            <Route path="gift-codes" element={<GiftCodes />} />
            <Route path="logs" element={<LogsManagement />} />
            <Route path="m3u-history" element={<M3uHistory />} />
            <Route path="settings" element={<SettingsManagement />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
